<template>
	<section id="Inmueble" class="sectionTemplate">
		<div class="container-fluid xs md xxl">
			<div class="row">
				<div class="col">
					<h2 class="titleDefault align-items-center">Inmuebles</h2>
				</div>
			</div>
			<div class="row mx-n3">
				<div v-for="item in inmueblesList" :key="item.id" class="col-12 col-md-6 col-lg-3 p-3 d-flex flex-column">
					<InmuebleItem :item="item"/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import InmuebleItem from "./InmuebleItem.vue"
	import mixinInmuebles from '@/libs/mixins/mixinInmuebles'
	export default {
		name: 'Inmueble',
		mixins: [mixinInmuebles],
		components: {
			InmuebleItem
		},
	}
</script>

<style>
	
</style>